<template>
  <div class="page">
    <Tabs class="tabs" :tab-list="menuList" title="商户管理" />
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'merchants',
  data() {
    return {
      // 切换目录
      menuList: [
        {
          routerName: 'merchants',
          text: '子商户进件',
        }
      ],
    };
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
</style>
